<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="props.item.href"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <BoxIcon padding="8px" class="mr-3">
            <v-icon medium color="#fff">add</v-icon>
          </BoxIcon>
          <h1 style="display: inline">Crear ruta</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <v-stepper v-model="step">
          <v-stepper-header class="border-container bg-white">
            <v-stepper-step
              :complete="step > 1"
              step="1"
              style="margin-left: auto; margin-right: auto"
            >
              <span class="text--primary">Datos</span>
            </v-stepper-step>
            <ArrowStep />
            <v-stepper-step
              :complete="step > 2"
              step="2"
              style="margin-right: 50%"
            >
              <span class="text--primary">Selección de alumnos</span>
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <div class="border-container bg-white pa-4">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-layout align-center row>
                      <CircleNumber text="01" />
                      <span
                        class="pl-2 subheading font-weight-medium text-uppercase"
                      >
                        Datos generales
                      </span>
                    </v-layout>

                    <v-layout row wrap class="ma-3 border-container">
                      <v-flex xs12 md6>
                        <div
                          class="ml-3 mt-4"
                          style="max-height: 500px; overflow: scroll"
                        >
                          <div>
                            <p class="font-weight-medium">Nombre de la ruta</p>
                            <div class="mb-2 h_custom_imput">
                              <div class="d-flex align-center">
                                <v-text-field
                                  class="border-container"
                                  style="
                                    height: 40px;
                                    width: 100%;
                                    font-size: 1.2em;
                                  "
                                  v-model="form.name"
                                  flat
                                  hide-details
                                  solo
                                  hide-selected
                                  dense
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <p class="font-weight-medium">
                              Seleccionar el tipo de ruta
                            </p>
                            <div class="mb-2 h_custom_imput">
                              <div class="d-flex align-center">
                                <v-select
                                  v-model="form.routeType"
                                  class="border-container"
                                  style="
                                    height: 40px;
                                    width: 100%;
                                    font-size: 1.2em;
                                  "
                                  :items="routeTypes"
                                  flat
                                  hide-details
                                  solo
                                  hide-selected
                                  dense
                                />
                              </div>
                            </div>
                          </div>
                          <div class="mb-2">
                            <v-tooltip right max-width="200">
                              <template v-slot:activator="{ on }">
                                <p
                                  v-on="on"
                                  class="mb-2 font-weight-medium"
                                  style="display: flex; width: fit-content"
                                >
                                  Asignar conductor (opcional)
                                  <v-icon color="primary">info</v-icon>
                                </p>
                              </template>
                              El conductor que selecciones, podrá visualizar y
                              hacer uso de la ruta desde su aplicación.
                            </v-tooltip>
                            <div class="h_custom_imput">
                              <v-autocomplete
                                class="border-container"
                                style="
                                  height: 40px;
                                  width: 100%;
                                  font-size: 1.2em;
                                "
                                flat
                                hide-details
                                solo
                                hide-selected
                                dense
                                clearable
                                v-model="form.selected"
                                :items="collaborators"
                                :item-text="collaboratorName"
                                item-value="id"
                                no-data-text="No hay resultados"
                              />
                            </div>
                          </div>
                          <div>
                            <p class="font-weight-medium ml-4 pl-2">
                              Agregar origen
                            </p>
                            <div class="mb-2 h_custom_imput">
                              <div class="d-flex align-center">
                                <v-icon class="mr-2">
                                  radio_button_unchecked
                                </v-icon>
                                <v-text-field
                                  class="border-container"
                                  style="
                                    height: 40px;
                                    width: 100%;
                                    font-size: 1.2em;
                                  "
                                  v-model="form.origin.name"
                                  flat
                                  hide-details
                                  solo
                                  hide-selected
                                  dense
                                  @click="setFocusedPin(form.origin)"
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <p class="font-weight-medium ml-4 pl-2">Destino</p>
                            <div class="mb-2 h_custom_imput">
                              <div class="d-flex align-center">
                                <v-icon color="primary" class="mr-2">
                                  location_on
                                </v-icon>
                                <v-text-field
                                  class="border-container"
                                  style="
                                    height: 40px;
                                    width: 100%;
                                    font-size: 1.2em;
                                  "
                                  v-model="form.destinations[0].name"
                                  flat
                                  hide-details
                                  solo
                                  hide-selected
                                  dense
                                  @click="setFocusedPin(form.destinations[0])"
                                />
                              </div>
                            </div>
                          </div>
                          <v-btn
                            color="black"
                            flat="flat"
                            class="border-container ma-1 pa-2"
                            @click="onAddDestination"
                          >
                            Agregar otro destino
                          </v-btn>
                          <div>
                            <p
                              v-show="form.destinations.length - 1 !== 0"
                              class="font-weight-medium"
                            >
                              Destinos
                            </p>
                            <div
                              v-for="(destination, index) in form.destinations"
                              v-if="index >= 1"
                              :key="destination.id"
                              class="mb-2 h_custom_imput"
                            >
                              <div class="d-flex align-center">
                                <v-icon color="primary" class="mr-2">
                                  transfer_within_a_station
                                </v-icon>
                                <v-text-field
                                  class="border-container"
                                  style="
                                    height: 40px;
                                    width: 100%;
                                    font-size: 1.2em;
                                  "
                                  flat
                                  hide-details
                                  solo
                                  hide-selected
                                  dense
                                  v-model="destination.name"
                                  append-icon="delete"
                                  @click:append="
                                    onDeleteDestination(destination)
                                  "
                                  @click="setFocusedPin(destination)"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs12 md6>
                        <GmapMap
                          ref="mapSettings"
                          :center="{
                            lat:
                              mapCenterFocus.lat !== undefined
                                ? mapCenterFocus.lat
                                : 10,
                            lng:
                              mapCenterFocus.lng !== undefined
                                ? mapCenterFocus.lng
                                : 10,
                          }"
                          style="height: 500px; margin-top: 3px"
                          :options="mapConfig"
                        >
                          <!-- ORIGIN PIN -->
                          <GmapMarker
                            :position="{
                              lat: form.origin.latitude,
                              lng: form.origin.longitude,
                            }"
                            :draggable="true"
                            :title="form.origin.name"
                            :label="form.origin.name"
                            :icon="markerDoorIcon"
                            @dragend="markerLocation($event, form.origin)"
                          />
                          <!-- DESTINATIONS PINS -->
                          <GmapMarker
                            v-for="destination in form.destinations"
                            :position="{
                              lat: destination.latitude,
                              lng: destination.longitude,
                            }"
                            :draggable="true"
                            :title="destination.name"
                            :label="destination.name"
                            :icon="markerDoorIcon"
                            @dragend="markerLocation($event, destination)"
                          />
                          <v-toolbar
                            dense
                            color="transparent"
                            floating
                            id="toolbarCreateRoute"
                            class="titleSearch elevation-0"
                          >
                            <v-text-field
                              class="mx-3 mt-4"
                              @keyup.enter="searchName"
                              :label="
                                $t('configuration.main_school_settings.search')
                              "
                              prepend-inner-icon="search"
                              clearable
                              solo
                            ></v-text-field>
                          </v-toolbar>
                        </GmapMap>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout align-center justify-end class="pa-4">
                      <v-btn
                        color="primary"
                        flat="flat"
                        class="border-container ma-1 pa-2"
                        :disabled="!isValidNextStepBtn()"
                        @click="next"
                      >
                        Siguiente
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
            </v-stepper-content>
            <v-stepper-content step="2">
              <div class="border-container bg-white pa-4">
                <v-layout row wrap>
                  <Audience
                    target-type="ROUTE"
                    @selectedAudience="onSelectedAudience"
                    @selectedItemsIds="onSelectedItemsIds"
                  >
                    <template v-slot:titleTarget>
                      <CircleNumber text="02" />
                      <span
                        class="pl-2 subheading font-weight-medium text-uppercase"
                      >
                        Selecciona los alumnos para el transporte
                      </span>
                    </template>
                    <template v-slot:titleItems>
                      <span
                        class="pt-1 pl-2 subheading font-weight-medium text-uppercase"
                      >
                        Audiencia
                      </span>
                    </template>
                  </Audience>
                  <v-flex xs12>
                    <v-layout align-center justify-space-between class="pa-4">
                      <v-btn
                        color="primary"
                        flat="flat"
                        class="border-container ma-1"
                        @click="pevStep"
                      >
                        Atrás
                      </v-btn>
                      <v-btn
                        color="primary"
                        flat="flat"
                        class="border-container ma-1 pa-2"
                        :disabled="!isValidCreateBtn()"
                        @click="createItem"
                      >
                        Crear ruta
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </div>
    <Loading v-model="createOptions.loading" text="Creando ruta..." />
    <Error v-model="createOptions.showError" :text="createOptions.message" />
    <Success
      v-model="createOptions.showSuccess"
      :text="createOptions.message"
    />
  </div>
</template>

<script>
import { mapSettings } from '@/Catalogs/mapSettings.js'
import { gmapApi } from 'vue2-google-maps'
import { mapGetters } from 'vuex'
import {
  Destination,
  LevelsGroupsHandler,
  StudentType,
  StudentsOrSubgroupHandler,
  parseChipStudentsFromArray,
  parseGroupsFromArray,
  parseLevelsFromArray,
  parseSubGroups,
} from '../../../../../Mixins/audience.js'
import Error from '../../../../Dialogs/Error.vue'
import Loading from '../../../../Dialogs/Loading.vue'
import Success from '../../../../Dialogs/Success.vue'
import ArrowStep from '../../../../generic/arrowStep.vue'
import Audience from '../../../../generic/audience.vue'
import BoxIcon from '../../../../generic/boxIcon.vue'
import CircleNumber from '../../../../generic/circleNumber.vue'
import CustomChip from '../../../../generic/customChip.vue'
import RadioBox from '../../../../generic/radioBox.vue'
import TargetAudience from '../../../../generic/targetAudience.vue'

export default {
  components: {
    CircleNumber,
    ArrowStep,
    TargetAudience,
    BoxIcon,
    RadioBox,
    CustomChip,
    Loading,
    Error,
    Success,
    Audience,
  },
  data: () => ({
    map: undefined,
    /**
     * @type {Destination}
     */
    tempDestination: undefined,
    googleMapsInitialized: false,
    mapCenterFocus: { lat: undefined, lng: undefined, indexFocus: undefined },
    step: 1,
    routeTypes: [
      {
        id: 1,
        text: 'Ida al colegio',
        value: 'TO_SCHOOL',
      },
      {
        id: 2,
        text: 'Vuelta a casa',
        value: 'FROM_SCHOOL',
      },
    ],
    form: {
      name: '',
      origin: new Destination({ latitude: 10, longitude: 10 }),
      /**
       * @type {Array<Destination>}
       */
      destinations: [new Destination({ latitude: 0, longitude: 0 })],
      /**
       * @type {'INSTITUTION'|'LEVELS'|'EXTRA_LEVELS'|'GROUPS'|'SUBGROUPS'|'STUDENTS'}
       */
      target: 'INSTITUTION',
      selected: undefined,
      /**
       * @type {Array<Number>}
       */
      selectedItemsIds: [],
      routeType: undefined,
    },
    breadcrumbs: [
      {
        text: 'Transporte Escolar',
        disabled: false,
        href: '/es/panel/school_transportation',
      },
      {
        text: 'Crear ruta',
        disabled: true,
        href: '/es/panel/school_transportation/create',
      },
    ],
    collaborators: [],
    createOptions: {
      showSuccess: false,
      showError: false,
      loading: false,
      message: '',
    },
  }),
  async mounted() {
    this.form.routeType = this.routeTypes[0].value

    this.initLevelsGradeGroupslevels().then((e) => {
      if (e === undefined) return

      this.extraLevels = new LevelsGroupsHandler(
        'levelId',
        parseLevelsFromArray,
        e.extracurricular
      )
      this.levels = new LevelsGroupsHandler(
        'levelId',
        parseLevelsFromArray,
        e.levels
      )
      this.groups = new LevelsGroupsHandler(
        'groupId',
        parseGroupsFromArray,
        e.levels
      )
    })

    this.subgroups = new StudentsOrSubgroupHandler({
      targetId: 'groupId',
      api: this.$store,
      apiUrl: 'subgroups/getSubgroups',
      itemParser: parseSubGroups,
    })

    this.students = new StudentsOrSubgroupHandler({
      targetId: 'id',
      api: this.$store,
      apiUrl: 'student/getSelectedStudentsFirst',
      itemParser: parseChipStudentsFromArray,
      studentsParams: { idRoute: undefined, type: StudentType.ROUTE },
    })

    this.subgroups.getItems()
    this.students.getItems()

    this.$refs.mapSettings.$mapPromise.then((map) => {
      this.map = map
      this.googleMapsInitialized = true
      const input = document.getElementById('toolbarCreateRoute')
      new google.maps.places.SearchBox(input)
      map.controls[google.maps.ControlPosition.TOP_CENTER].push(input)
    })

    this.$store
      .dispatch('visits/getVisits', {
        page_size: 1,
        offset: 1,
      })
      .then((response) => {
        this.collaborators = response.data.collaborators
      })
      .catch((err) => {
        console.log(err)
      })

    this._setupMap()
  },
  methods: {
    searchName(e) {
      const request = {
        query: e.target.value,
        fields: ['name', 'geometry', 'formatted_address'],
      }
      const temp = this
      const service = new google.maps.places.PlacesService(this.map)

      service.findPlaceFromQuery(request, function (results, status) {
        if (status !== google.maps.places.PlacesServiceStatus.OK) return
        const tempDestination = new Destination({
          latitude: results[0].geometry.location.lat(),
          longitude: results[0].geometry.location.lng(),
        })

        temp._relocateTempDestination(tempDestination)
        temp.setFocusedPin(tempDestination, false)
      })
    },
    collaboratorName(collaborator) {
      return `${collaborator.firstName} ${collaborator.lastName}`
    },
    onAddDestination() {
      this.form.destinations.push(
        new Destination({
          latitude: this.getBranch.markLatitude,
          longitude: this.getBranch.markLongitude,
        })
      )
    },
    markerLocation(event, marker) {
      marker.latitude = event.latLng.lat()
      marker.longitude = event.latLng.lng()
    },
    /**
     * @param {Destination} destination
     */
    onDeleteDestination(destination) {
      this.form.destinations = this.form.destinations.filter(
        (e) => e.id != destination.id
      )
    },
    pevStep() {
      this.step = 1
    },
    next() {
      this.step = 2
    },
    async createItem() {
      this.createOptions.loading = true

      const body = {
        name: this.form.name,
        originName: this.form.origin.name,
        originLatitude: this.form.origin.latitude,
        originLongitude: this.form.origin.latitude,
        idWebAdmin: this.form.selected,
        type: this.form.routeType,
        destinations: this.form.destinations.map((e, i) => ({
          ...e,
          id: undefined,
          index: i + 1,
        })),
        institutional: this.form.target === 'INSTITUTION',
        levelIds:
          this.form.target === 'LEVELS'
            ? this.form.selectedItemsIds
            : undefined,
        extraLevelIds:
          this.form.target === 'EXTRA_LEVELS'
            ? this.form.selectedItemsIds
            : undefined,
        gradeGroupIds:
          this.form.target === 'GROUPS'
            ? this.form.selectedItemsIds
            : undefined,
        subgroupIds:
          this.form.target === 'SUBGROUPS'
            ? this.form.selectedItemsIds
            : undefined,
        studentIds:
          this.form.target === 'STUDENTS'
            ? this.form.selectedItemsIds
            : undefined,
      }

      try {
        await this.$store.dispatch('transport/createRoute', body)

        this.createOptions.message = 'Ruta creada con éxito.'
        this.createOptions.showSuccess = true

        const time = setTimeout(() => {
          this.$router.push({ name: 'schoolTransportation' })
          clearTimeout(time)
        }, 2000)
      } catch (error) {
        console.log(error)
        const customErrors = {
          404: 'No se encontró el colaborador seleccionado.',
          409: 'Ups, no se obtuvo ningún estudiante a partir de la audiencia proporcionada.',
        }

        this.createOptions.showSuccess = false
        this.createOptions.showError = true
        this.createOptions.message = customErrors[error.response.status]
          ? customErrors[error.response.status]
          : 'Error al crear ruta'
      } finally {
        this.createOptions.loading = false
      }
    },
    isValidCreateBtn() {
      if (
        this.createOptions.loading ||
        this.createOptions.showSuccess ||
        this.createOptions.showError
      )
        return false

      if (this.form.target === 'INSTITUTION') {
        return true
      }
      if (this.form.selectedItemsIds.length !== 0) {
        return true
      }

      return false
    },
    isValidNextStepBtn() {
      if (
        this.form.name.trim() !== '' &&
        this.form.origin.name.trim() !== '' &&
        this.form.destinations.every((e) => e.name.trim() !== '')
      ) {
        return true
      }

      return false
    },
    onSelectedAudience(selected) {
      this.form.target = selected
    },
    onSelectedItemsIds(ids) {
      this.form.selectedItemsIds = ids
    },
    async initLevelsGradeGroupslevels() {
      try {
        const { data } = await this.$store.dispatch('tutor/getLevelsExtraTool')

        return data.entity
      } catch (error) {
        console.log(error)
        return
      }
    },
    /**
     *
     * @param {Destination} destination
     */
    setFocusedPin(destination, setTempDestination = true) {
      this.mapCenterFocus.lat = destination.latitude
      this.mapCenterFocus.lng = destination.longitude
      if (!setTempDestination) return

      this._setTempDestination(destination)
    },
    /**
     * @param {Destination} destination
     */
    _setTempDestination(destination) {
      this.tempDestination = destination
    },
    /**
     * @param {Destination} destination
     */
    _relocateTempDestination(destination) {
      this.tempDestination.latitude = destination.latitude
      this.tempDestination.longitude = destination.longitude
    },
    _setupMap() {
      if (this.getBranch !== undefined) {
        this.mapCenterFocus.lat = this.getBranch.markLatitude
        this.mapCenterFocus.lng = this.getBranch.markLongitude

        this.form.origin.latitude = this.getBranch.markLatitude
        this.form.origin.longitude = this.getBranch.markLongitude

        this.form.destinations[0].latitude = this.getBranch.markLatitude
        this.form.destinations[0].longitude = this.getBranch.markLongitude
      }
    },
  },
  watch: {
    getBranch() {
      this._setupMap()
    },
  },
  computed: {
    google: gmapApi,
    mapConfig() {
      return {
        ...mapSettings,
        zoom: this.getBranch.zoom,
      }
    },
    markerSize() {
      if (!this.googleMapsInitialized) return null
      return new window.google.maps.Size(48, 48)
    },
    markerPointOrigin() {
      if (!this.googleMapsInitialized) return null
      return new window.google.maps.Point(0, 0)
    },
    markerPointAnchor() {
      if (!this.googleMapsInitialized) return null
      return new window.google.maps.Point(24, 48)
    },
    markerSizePointLabel() {
      if (!this.googleMapsInitialized) return null
      return new window.google.maps.Point(24, 0)
    },
    markerDoorIcon() {
      return {
        url: require('@/assets/mapIcons/if_map-marker_3688470.png'),
        scaledSize: this.markerSize,
        origin: this.markerPointOrigin,
        anchor: this.markerPointAnchor,
        labelOrigin: this.markerSizePointLabel,
      }
    },
    ...mapGetters(['getBranch']),
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  padding: 1px;
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}
.pagination {
  display: flex;
  justify-content: center;
}
.loading_height {
  height: 300px;
}
.items_box_pills {
  max-height: 300px;
  overflow-y: scroll;
}
/* reset global css */
::v-deep .v-btn {
  text-transform: initial;
}
::v-deep .v-stepper,
::v-deep .v-stepper__header {
  background-color: initial;
  box-shadow: none;
}
::v-deep .v-stepper__header {
  overflow: hidden;
}
::v-deep .v-stepper__content {
  padding-left: 0;
  padding-right: 0;
}

/* generic */
.bg-white {
  background-color: white;
}

.h_custom_imput ::v-deep .v-text-field.v-text-field--solo .v-input__control {
  max-height: 35px !important;
  min-height: 35px !important;
}

.circle_icon {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 1px solid black;
}
</style>
